// dependencies
import React from "react";
import { useIntl } from "react-intl";

type IProps = {
  floor: number;
};

const Floor: React.FunctionComponent<IProps> = (props) => {
  const { floor } = props;
  const intl = useIntl();

  return (
    <>
      {intl.formatMessage(
        {
          defaultMessage:
            "{floor, plural, =0 {rez-de-chaussée} =1 {#er étage} =-1 {#er étage} other {#ème étage}}",
        },
        { floor }
      )}
    </>
  );
};

export default Floor;
